import React from 'react';
import { YStack, Spinner, Text } from 'tamagui';

interface LoadingOverlayProps {
  isVisible: boolean;
  backgroundColor?: string;
  zIndex?: number;
  spinnerSize?: 'small' | 'large';
  text?: string;
}

export const LoadingOverlay: React.FC<LoadingOverlayProps> = ({
  isVisible,
  backgroundColor,
  zIndex = 1000,
  spinnerSize = 'large',
  text,
}) => {
  if (!isVisible) return null;

  return (
    <YStack
      position="absolute"
      top={0}
      left={0}
      right={0}
      bottom={0}
      justifyContent="center"
      alignItems="center"
      backgroundColor={backgroundColor}
      zIndex={zIndex}
      pointerEvents="none">
      <Spinner size={spinnerSize} />
      {text && <Text>{text}</Text>}
    </YStack>
  );
};
